import React from 'react';
import { ButtonText, CenteredContainer, DescriptionContainer, DescriptionText, HeadingContainer, HeadingText, MainPageLinkContainer, StyledErrorPage, StyledWrapper, HomeButton, } from './ErrorPage.styles';
import { useHistory } from 'react-router-dom';
import ErrorPageDrop from '@innovyze/stylovyze/lib/components/ErrorPage/ErrorPageDrop.svg';
import { Svg } from '@innovyze/stylovyze/lib/components/Svg';
export const ErrorPage = ({ resetErrorBoundary, }) => {
    const history = useHistory();
    return (React.createElement(StyledWrapper, null,
        React.createElement(StyledErrorPage, null,
            React.createElement(CenteredContainer, null,
                React.createElement(HeadingContainer, null,
                    React.createElement(Svg, { svg: ErrorPageDrop, title: "error image" }),
                    React.createElement(HeadingText, null, "Info360 has run into a problem")),
                React.createElement(DescriptionContainer, null,
                    React.createElement(DescriptionText, null,
                        "The application is currently not responding. Refreshing this page may resolve the issue.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "If you are still seeing this page after refreshing your browser window, please contact our Support team for assistance: \u00A0",
                        React.createElement("a", { href: "https://www.autodesk.com/support/contact-support" }, "https://www.autodesk.com/support/contact-support"))),
                React.createElement(MainPageLinkContainer, null,
                    React.createElement(HomeButton, { variant: "outlined", color: "primary", onClick: () => {
                            history.push('/');
                            setTimeout(() => {
                                resetErrorBoundary();
                            }, 100);
                        } },
                        React.createElement(ButtonText, null, "HOME")))))));
};
export default ErrorPage;
